import { useEffect } from "react";
import { TextField } from "@mui/material";
import { Controller, useFormState, useWatch } from "react-hook-form";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

function DateOfSurgeryField({ control, setValue }) {
  const { errors } = useFormState({ control });
  const isSurgical = useWatch({ control, name: "surgical" });

  useEffect(() => {
    if (!isSurgical) setValue("date_of_surgery", null);
  }, [isSurgical, setValue]);

  const helperText = isSurgical
    ? "Patient's date of surgery"
    : "Unneeded for non-op patients";

  return (
    <Controller
      name="date_of_surgery"
      control={control}
      rules={{
        required: "Date of surgery is required for surgical patients",
      }}
      disabled={!isSurgical}
      render={({ field }) => (
        <MobileDatePicker
          {...field}
          label="Date of Surgery"
          inputFormat="MM/DD/YYYY"
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={!!errors.date_of_surgery}
              helperText={errors.date_of_surgery?.message ?? helperText}
            />
          )}
        />
      )}
    />
  );
}

export default DateOfSurgeryField;
